<template>
  <div ref="navbar" class="links">
    <SectionTitle :title="title" />
  </div>
</template>

<script>
  import SectionTitle from '../commonComponents/SectionTitle'
  export default {
    name: 'Links',
    components: {
      SectionTitle
    },
    data() {
      return {
        title: 'Links'
      }
    }
  }
</script>
